import type { SobreimpresoCreateConfig } from './types';

export const SOBREIMPRESO_SETTINGS_KEY = 'sobreimpreso';

export const SOBREIMPRESO_FACTORY_DEFAULTS = {
  fontWeight: 700 as number | string,
  fontStyle: 'normal' as const,
  textAlign: 'left' as const,
  borderRadius: 32,
  paddingX: 32,
  paddingY: 16,
  minHeight: 0,
  stroke: '#000000',
  strokeWidth: 0
} as const;

export const SOBREIMPRESO_INSERT_DEFAULTS: Omit<SobreimpresoCreateConfig, 'left' | 'top'> = {
  width: 480,
  text: 'Sobreimpreso',
  fill: {
    kind: 'linear',
    angle: 0,
    stops: [
      { offset: 0, color: 'rgba(0, 43, 218, 1)' },
      { offset: 1, color: 'rgba(199, 222, 254, 0.8)' }
    ]
  },
  textFill: '#FFFFFF',
  fontFamily: 'Arial',
  fontSize: 36
};
